import { AxiosResponse } from "axios";
import { API_ROUTE } from "../const/apiRoute";
import { HanderResponse } from "../_base/helper/FunctionHelper";
import { apiCust } from "../library/axios";
import { isNullOrUndefined } from "../_base/extension/StringExtension";
import { NotificationExtension } from "../_base/extension/NotificationExtension";

export const excuteWarranteeSamsungSession = async (
  param: any
): Promise<any> => {
  try {
    const response: AxiosResponse = await apiCust.post(
      `${API_ROUTE.EXCUTE_WARRANTEE_SAMSUNG_SESSION}${param}`
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Chạy thành công !");
    } else if (response != null) NotificationExtension.Fails("Chạy thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const createWarranteeSamsungSession = async (
  data: any
): Promise<any> => {
  try {
    const response: AxiosResponse = await apiCust.post(
      `${API_ROUTE.CREATE_WARRANTEE_SAMSUNG_SESSION}`,
      data
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Thêm mới thành công !");
    } else if (response != null)
      NotificationExtension.Fails("Thêm mới thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const getDetailWarranteeSamsungSession = async (
  param: any
): Promise<any> => {
  try {
    const response: AxiosResponse = await apiCust.get(
      `${API_ROUTE.GET_DETAIL_WARRANTEE_SAMSUNG_SESSION}${param}`
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const modifyWarranteeSamsungSession = async (
  data: any
): Promise<any> => {
  try {
    const response: AxiosResponse = await apiCust.post(
      `${API_ROUTE.MODIFY_WARRANTEE_SAMSUNG_SESSION}`,
      data
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Chỉnh sửa thành công !");
    } else if (response != null)
      NotificationExtension.Fails("Chỉnh sửa thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const deleteWarranteeSamsungSession = async (
  data: any
): Promise<any> => {
  try {
    const response: AxiosResponse = await apiCust.post(
      `${API_ROUTE.DELETE_WARRANTEE_SAMSUNG_SESSION}`,
      data
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Xoá phiên thành công !");
    } else if (response != null)
      NotificationExtension.Fails("Xoá phiên thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const getListWarranteeSamsung = async (param: any): Promise<any> => {
  try {
    const response: AxiosResponse = await apiCust.get(
      `${API_ROUTE.GET_LIST_WARRANTEE_SAMSUNG}${param}`
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const getAllWarranteeSamsung = async (param: any): Promise<any> => {
  try {
    const response: AxiosResponse = await apiCust.get(
      `${API_ROUTE.GET_ALL_WARRANTEE_SAMSUNG}${param}`
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const createWarranteeSamsung = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await apiCust.post(
      `${API_ROUTE.CREATE_WARRANTEE_SAMSUNG}`,
      data,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Thêm mới thành công !");
    } else if (response != null)
      NotificationExtension.Fails("Thêm mới thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const getDetailWarranteeSamsung = async (param: any): Promise<any> => {
  try {
    const response: AxiosResponse = await apiCust.get(
      `${API_ROUTE.GET_DETAIL_WARRANTEE_SAMSUNG}${param}`
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const modifyWarranteeSamsung = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await apiCust.post(
      `${API_ROUTE.MODIFY_WARRANTEE_SAMSUNG}`,
      data
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Chỉnh sửa thành công !");
    } else if (response != null)
      NotificationExtension.Fails("Chỉnh sửa thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const deleteWarranteeSamsung = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await apiCust.post(
      `${API_ROUTE.DELETE_WARRANTEE_SAMSUNG}`,
      data
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Xoá phiên thành công !");
    } else if (response != null)
      NotificationExtension.Fails("Xoá phiên thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};
